import React from 'react'
import { compose } from 'ramda'
import withAuth from 'hocs/withAuth'
import { withGql } from 'hocs/withGql'
import withVertical from 'hocs/withVertical'

const IndexPage = () => {
    return <div />
}

export default compose(
    withGql({}),
    withVertical,
    withAuth({ allowedUserTypes: [] }),
)(IndexPage)
